var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import classNames from "classnames";
import { LanguageSelector } from "../LanguageSelector";
import { DEFAULT_LANGUAGE } from "../LanguageSelector/constants";
const defaultProps = {
    "data-testid": "tecma-header-language-selector",
    onChangeLanguage: () => { },
    currentLanguage: DEFAULT_LANGUAGE,
};
const HeaderLanguageSelector = (_a) => {
    var { className, style, onChangeLanguage, currentLanguage, languages } = _a, rest = __rest(_a, ["className", "style", "onChangeLanguage", "currentLanguage", "languages"]);
    const classList = classNames("tecma-header-language-selector", className);
    return (_jsx(LanguageSelector, Object.assign({ className: classList, transparent: true, onChangeLanguage: onChangeLanguage, currentLanguage: currentLanguage, languages: languages, triggerIcon: "translate", position: {
            vertical: "bottom",
            horizontal: "right",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "right",
        } }, rest)));
};
HeaderLanguageSelector.defaultProps = defaultProps;
export default memo(HeaderLanguageSelector);
